/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type BuyMobileNav_viewer = {
    readonly " $fragmentRefs": FragmentRefs<"BuyMobileNavRefineMenuFilters_viewer">;
    readonly " $refType": "BuyMobileNav_viewer";
};
export type BuyMobileNav_viewer$data = BuyMobileNav_viewer;
export type BuyMobileNav_viewer$key = {
    readonly " $data"?: BuyMobileNav_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"BuyMobileNav_viewer">;
};



const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "BuyMobileNav_viewer",
  "selections": [
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "BuyMobileNavRefineMenuFilters_viewer"
    }
  ],
  "type": "Viewer",
  "abstractKey": null
};
(node as any).hash = '9e293ca5c08edabde5932d099c01015a';
export default node;
